export const Vehicle = () => null;
